export default "__VITE_ASSET__E5ByCaol__"